<template>
  <ag-modal-container
    :title="$t('tokens.title.viewDemands')"
    width="900px"
    @close="back"
  >
    <tokens-demand-view v-if="value" :value="value" />
  </ag-modal-container>
</template>

<script>
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import TokensDemandView from '../components/TokensDemandView'

export default {
  name: 'TokensDemandViewContainer',
  components: {
    AgModalContainer,
    TokensDemandView,
  },
  props: {
    demandId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    value: null,
  }),
  watch: {
    $route: {
      immediate: true,
      async handler () {
        this.value = await Repositories.myCompany.getTokensDemand(this.demandId)
      },
    },
  },
  methods: {
    back () {
      this.$router.back()
    },
  },
}
</script>
